import React from 'react';
import { NumberInput } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';
export const ExcludePromptItem = '__lora_emhance__';

const PromptWeight = (props) => {
  const { text, isSimple, pos = {}, onChange } = props || {};
  let initScale = 1;
  let checkedValue = text;
  if (/\(/.test(text)) {
    initScale = parseFloat((text.match(/\d+\.\d+/) || [])[0]);
    const _val = (text.match(/\(([^:]+):/) || [])[1];
    if (_val) {
      checkedValue = _val;
    }
  }
  // const [scale, setScale] = useState(1.0);
  // useEffect(() => {
  //   if (initScale) {
  //     setScale(initScale);
  //   }
  // }, [initScale]);
  const handleInputScaleChange = (val) => {
    if (!val) {
      val = 0;
    }
    const _val = val.toFixed(1);
    const value = `(${checkedValue}: ${_val})`;
    onChange?.(checkedValue, value, pos);
    // setScale(val);
  };

  if (!text || isSimple) {
    return null;
  }
  return (
    <div
      data-trigger="prompt-weight"
      className={`absolute z-10 rounded-[2px] bg-[#FFF]`}
      style={{ left: pos.x, top: pos.y }}
    >
      <NumberInput
        min={0.1}
        defaultValue={initScale}
        leftSection={<span style={{ display: 'inline-block', width: '50px' }}>{translate('prompt_weight')}</span>}
        decimalScale={1}
        fixedDecimalScale
        className={'prompt-input-number'}
        max={5}
        step={0.1}
        onChange={handleInputScaleChange}
        style={{ width: '100px', height: '26px' }}
      />
    </div>
  );
};

export default PromptWeight;
